<template>
  <Treeselect
    @input="
      $emit(
        'change',
        options.find((opt) => opt[customReduce || 'Id'] === currentValue)
      )
    "
    v-model="currentValue"
    :class="{ invalid: errors.length > 0 }"
    :disabled="disabled"
    :options="options"
    :clearable="!noClearable"
    :default-expand-level="1"
    :normalizer="normalizer"
    :placeholder="$t(placeholder)"
    :noOptionsText="$t('ar_client_no_data')"
    :noResultsText="$t('ar_client_no_data')"
    :multiple="multiple"
    :limit-text="fnCount"
    :limit="1"
    :clear-on-select="false"
  >
    <!--  <div slot="before-list">
      <span class="vue-treeselect__check-mark" />
      <span slot="before-list" class="" >
        hello
      </span>
    </div> -->
    <template v-if="multiple" slot="before-list">
      <label @click="onSelectAll" style="margin-left: 5px" class="text-primary cursor-pointer">
        {{ $t("ar_client_select_all") }}
      </label>
    </template>
    <treeselect-tip slot="after-list" v-if="loading" type="loading" icon="loader"
      >{{ $t("ar_client_loading") }}...</treeselect-tip
    >
  </Treeselect>
</template>
<style lang="scss" src="./WidgetSelect.scss"></style>
<script>
import Treeselect from "@riophae/vue-treeselect";
import TreeselectTip from "@riophae/vue-treeselect/src/components/Tip.vue";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  name: "WidgetSelect",
  data: () => ({
    currentValue: null,
    options: [],
    loading: false,
  }),

  methods: {
    updateData(v) {
      this.$emit("input", v);
    },
    onSelectAll() {
      this.currentValue = this.options.map((opt) =>
        this.customReduce ? opt[this.customReduce] : opt["Id"]
      );
    },
    normalizer(node) {
      if (node) {
        let temp = {
          id: node.Id,
          label: node.isDisabled ? node[this.label] + this.disabledItemAfterFix : node[this.label],
        };
        if (this.customReduce) {
          temp["id"] = node[this.customReduce];
        }
        if (typeof node === "string") {
          temp = {
            id: node,
            label: node.isDisabled ? node + this.disabledItemAfterFix : node,
          };
        }

        return temp;
      }
    },
    fnCount(count) {
      return `(+ ${count})`;
    },

    getDataSource(dataSourceParams) {
      if (typeof this.dataSource === "function") {
        this.loading = true;
        this.dataSource(dataSourceParams).then((res) => {
          this.loading = false;
          if (res.Status === "200") {
            let tempOptions = [];

            const dataValues = Object.values(res.Data);
            dataValues.forEach((item) => {
              if (Array.isArray(item)) {
                tempOptions = item;
              }
            });
            if (this.customOptions && typeof this.customOptions === "function") {
              tempOptions = this.customOptions(tempOptions);
            }
            if (this.disabledItem) {
              const disabledItem = this.disabledItem;
              tempOptions = tempOptions.map(function (opt) {
                return { ...opt, isDisabled: disabledItem(opt) };
              });
            }
            this.options = tempOptions;
          }
        });
      } else {
        let tempOptions = this.dataSource;
        console.log(tempOptions, "1077");
        if (this.customOptions) {
          tempOptions = this.customOptions(tempOptions);
        }
        this.options = tempOptions;
      }
    },
  },
  computed: {
    isGreaterThanOneArrayCurrentValue() {
      return Array.isArray(this.currentValue) && this.currentValue.length > 1;
    },
  },

  created() {
    if (this.value) this.currentValue = this.value;
    this.getDataSource(this.dataSourceParams);
  },
  props: {
    disabledItemAfterFix: {
      type: String,
      default: "",
    },
    disabledItem: Function,
    defaultValue: [Number, String, Function],
    noClearable: Boolean,
    customOptions: Function,
    value: [String, Array, Number],
    dataSourceParams: {
      type: [Object, String, Array],
      nullable: true,
    },
    dataSource: {
      type: [Function, Array],
      required: true,
    },
    customReduce: {
      type: String,
    },
    label: String,
    required: Boolean,
    variant: String,
    placeholder: {
      type: String,
      default: "",
    },

    multiple: {
      type: Boolean,
    },
    errors: {
      type: Array,
      default() {
        return [];
      },
    },
    disabled: [Boolean, String, Number],
  },

  watch: {
    dataSourceParams: {
      handler: function (value, oldValue) {
        const isOldValueSameAsNewValue = JSON.stringify(value) === JSON.stringify(oldValue);
        if (value && !isOldValueSameAsNewValue) {
          this.getDataSource(value);
        }
      },
      deep: true,
    },
    value: {
      handler: function (v) {
        console.log(v, "167788");
        if (v && Array.isArray(v) && v.length === 0) {
          this.currentValue = null;
        } else if (v || v === 0 || v === "") {
          this.currentValue = v;
        }
      },
    },
    currentValue(val) {
      this.updateData(val);
    },
    dataSource: {
      handler(v) {
        if (v && Array.isArray(v)) {
          let tempOptions = this.dataSource;

          if (this.customOptions) {
            tempOptions = this.customOptions(tempOptions);
          }
          this.options = tempOptions;
        }
      },
      deep: true,
    },
    options: {
      handler(v) {
        if (v && v.length > 0 && typeof this.defaultValue === "function") {
          console.log(this.normalizer(this.defaultValue(v))["id"], "2100");
          this.currentValue = this.normalizer(this.defaultValue(v))["id"];
        }
      },
      deep: true,
    },
  },
  components: {
    TreeselectTip,
    Treeselect,
  },
};
</script>
